<script setup lang="ts">
import ResourceDialogEquipmentDetails from './ResourceDialogEquipmentDetails.vue';
import ResourceDialogUserDetails from './ResourceDialogUserDetails.vue';
import { Resource, ResourceFilter } from '/@types/resources';
import Icons from '/@utilities/icons';

defineProps<{
  resource: Resource;
  resourceFilters: ResourceFilter[];
  close: Function;
}>();
</script>

<template>
  <div class="dialog">
    <header class="head">
      <df-button v-on:click="close()">
        <template v-slot:icon>
          <df-icon :code="Icons.ArrowLeft" />
        </template>
      </df-button>

      <h1 class="title-md">{{ resource.name }}</h1>
    </header>

    <dl v-if="resource.type === 'equipment'" class="dl card" style="padding: 0">
      <ResourceDialogEquipmentDetails :resource="resource" />
    </dl>

    <dl class="dl card" style="padding: 0">
      <div class="dl__group dl__group--large">
        <dt class="dl__topic">Grupper</dt>
        <dd class="dl__description">
          <ul class="list">
            <li v-for="filter in resource.filters" :key="filter.id" class="list__item">
              <template
                v-for="f in resourceFilters.filter(({ id }) => id === filter.id)"
                :key="f.id"
              >
                {{ f.name }}
                <div class="badge" v-if="f.type">{{ f.type }}</div>
                <div class="badge badge--info" v-if="f.isUserSpecific">Personlig</div>
              </template>
            </li>
          </ul>
        </dd>
      </div>

      <ResourceDialogUserDetails v-if="resource.type === 'user'" :resource="resource" />
    </dl>
  </div>
</template>

<style scoped>
.list__item {
  margin: var(--gap-sm) 0;
}
</style>
